import { Loader } from "@circle-react-uikit/Loader";
import { ChatItem } from "@circle-react/components/Modals/MessagingModalCompass/LeftSidebar/List/BotChat/ChatItem";
import { useMessagingPaths } from "@circle-react/hooks/chatsV2/messaging/useMessagingPaths";
import { useCommunityInboxStore } from "@circle-react/hooks/chatsV2/store";
import type {
  ChatSortType,
  ChatType,
} from "@circle-react/types/CommunityBot/ChatSort";
import type { Chat } from "@circle-react/types/CommunityInbox/Chat";
import { useId } from "react";
import InfiniteScroll from "react-infinite-scroll-component";

import { useChatList } from "../../hooks/useCommunityChatList";
import { useCommunityInboxSync } from "../../hooks/useCommunityInboxSync";
import { EmptyChat } from "./EmptyChat";

export const ChatListComponent = ({
  activeSort,
  activeChatType,
  activeAgent,
}: {
  activeSort: ChatSortType;
  activeChatType: ChatType;
  activeAgent: { name: string; id: number };
}) => {
  const { isChatsLoading, hasNextPage, fetchNextPage } = useChatList({
    sort: activeSort,
    filter: "has_member_interaction",
    chatType: activeChatType,
    agentId: activeAgent.id,
  });
  const scrollableTargetId = useId();
  const { adminChats: chats, currentChatId } = useCommunityInboxStore();
  const { chatInboxPath } = useMessagingPaths();
  useCommunityInboxSync({
    activeChatType,
    agentId: activeAgent.id,
  });

  if (isChatsLoading) {
    return (
      <div className="h-full overflow-auto p-2">
        <Loader />
      </div>
    );
  }

  return (
    <>
      {chats.length == 0 && <EmptyChat />}
      <div
        id={scrollableTargetId}
        className="h-full min-h-0 grow basis-0 overflow-auto"
      >
        <InfiniteScroll
          scrollableTarget={scrollableTargetId}
          className="p-2"
          next={fetchNextPage}
          scrollThreshold={0.8}
          hasMore={Boolean(hasNextPage)}
          dataLength={chats.length}
          loader={<Loader center />}
        >
          {chats.map((chat: Chat) => {
            const isOpenChatRoom = chat.id == currentChatId;
            return (
              <ChatItem
                key={chat.id}
                chat={chat}
                path={chatInboxPath({ id: chat.id.toString() })}
                isUnread={!isOpenChatRoom && chat.has_unread_messages_for_admin}
              />
            );
          })}
        </InfiniteScroll>
      </div>
    </>
  );
};
